import * as React from "react";
import { forwardRef } from "react";
const SvgGlobal = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M9.00001 17C13.4183 17 17 13.4183 17 9.00001C17 4.58173 13.4183 1 9.00001 1C4.58173 1 1 4.58173 1 9.00001C1 13.4183 4.58173 17 9.00001 17Z",
	stroke: "#222222",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M1 9H17",
	stroke: "#222222",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M12.077 9.00001C11.9258 11.9255 10.8482 14.7272 9.00003 17C7.1518 14.7272 6.07423 11.9255 5.9231 9.00001C6.07423 6.07448 7.1518 3.27281 9.00003 1C10.8482 3.27281 11.9258 6.07448 12.077 9.00001V9.00001Z",
	stroke: "#222222",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgGlobal);
export default ForwardRef;
